export default __webpack_public_path__ + "static/media/friim_bg_2.39f50007.jpg";